import { render, staticRenderFns } from "./FileDragDrop.vue?vue&type=template&id=38c86036&scoped=true"
import script from "./FileDragDrop.vue?vue&type=script&lang=js"
export * from "./FileDragDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDragDrop.vue?vue&type=style&index=0&id=38c86036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c86036",
  null
  
)

export default component.exports